var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticStyle: { height: "55px" } },
        [
          _vm._v("\n        Skier Types\n        "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("modal-close")
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "p-2" },
        [
          _c(
            "v-list",
            [
              _vm._l(_vm.skier_types, function (item, index) {
                return [
                  _c(
                    "v-list-item",
                    { key: "skier_type_" + item.id },
                    [
                      _c("v-list-item-content", [
                        _c("h5", [_vm._v(_vm._s(item.title))]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              (item.content || "")
                                .replaceAll("\\r", "")
                                .replaceAll("\\n", "")
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  index < _vm.skier_types.length - 1
                    ? _c("v-divider", { key: "_divider" + index })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }